import axios from 'axios';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: 'https://auth.ignaspanavas.com/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    console.log('API Request:', config.method?.toUpperCase(), config.baseURL + config.url);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token refresh
api.interceptors.response.use(
  (response) => {
    console.log('API Response:', response.config.url, response.status, response.data);
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('refreshToken');
        if (refreshToken) {
          const response = await axios.post('https://auth.ignaspanavas.com/api/auth/refresh', {
            refreshToken: refreshToken
          });

          const { token: newToken, refreshToken: newRefreshToken } = response.data;
          
          localStorage.setItem('token', newToken);
          localStorage.setItem('refreshToken', newRefreshToken);
          
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return api(originalRequest);
        }
      } catch (refreshError) {
        // Refresh failed, redirect to login
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        window.location.href = '/';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

// API methods
export const authAPI = {
  refresh: (refreshToken) => api.post('/auth/refresh', { refreshToken }),
};

export const userAPI = {
  getProfile: () => api.get('/users/profile'),
  updateProfile: (data) => api.put('/users/profile', data),
  // Normalize response to return the inner dashboard object
  getDashboard: () => api.get('/users/dashboard').then(res => res.data?.data),
  deleteAccount: () => api.delete('/users/account'),
};

export const socialAPI = {
  // Normalize to return the array of accounts directly
  getAccounts: () => api.get('/social/accounts').then(res => res.data),
  getData: (platform, timeframe) => api.get(`/social/data/${platform}?timeframe=${timeframe}`),
  getAllData: (timeframe) => api.get(`/social/data?timeframe=${timeframe}`),
  disconnectAccount: (accountId) => api.delete(`/social/accounts/${accountId}`),
  refreshData: (platform) => api.post(`/social/refresh/${platform}`),
};

export default api;
